import { useEffect } from "react";
import { contactInfo, media, siteBaseUrl } from "@/data/siteContent";

const upsertMeta = (selector, attrs) => {
  let element = document.head.querySelector(selector);
  if (!element) {
    element = document.createElement("meta");
    document.head.appendChild(element);
  }
  Object.entries(attrs).forEach(([key, value]) => element.setAttribute(key, value));
};

const upsertLink = (rel, href) => {
  let element = document.head.querySelector(`link[rel="${rel}"]`);
  if (!element) {
    element = document.createElement("link");
    element.setAttribute("rel", rel);
    document.head.appendChild(element);
  }
  element.setAttribute("href", href);
};

const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "MovingCompany",
  name: "Has Kırıkhan Nakliyat",
  url: siteBaseUrl,
  image: `${siteBaseUrl}${media.logo.replace(/\?.*$/, "")}`,
  telephone: "+905015771091",
  priceRange: "₺₺",
  address: {
    "@type": "PostalAddress",
    streetAddress: "Cumhuriyet Mah. 338 Sk. Kaynaklar İnşaat Sitesi Kaynak Apt No: 22 İç Kapı No: 2",
    addressLocality: "Kırıkhan",
    addressRegion: "Hatay",
    addressCountry: "TR",
  },
  geo: {
    "@type": "GeoCoordinates",
    latitude: contactInfo.geo.latitude,
    longitude: contactInfo.geo.longitude,
  },
  areaServed: ["Kırıkhan", "Hatay", "Türkiye"],
  openingHoursSpecification: [{
    "@type": "OpeningHoursSpecification",
    dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
    opens: "08:00",
    closes: "22:00",
  }],
  hasOfferCatalog: {
    "@type": "OfferCatalog",
    name: "Has Kırıkhan Nakliyat Hizmetleri",
    itemListElement: ["Evden Eve Nakliyat", "Ofis Taşıma", "Şehir İçi Nakliyat", "Şehirler Arası Nakliyat", "Asansörlü Taşıma"].map((name) => ({
      "@type": "Offer",
      itemOffered: { "@type": "Service", name },
    })),
  },
};

export default function SEO({ title, description, path = "/", image = media.hero, schemaType = "WebPage" }) {
  useEffect(() => {
    const canonicalUrl = `${siteBaseUrl}${path}`;
    document.title = title;
    upsertMeta('meta[name="description"]', { name: "description", content: description });
    upsertMeta('meta[property="og:title"]', { property: "og:title", content: title });
    upsertMeta('meta[property="og:description"]', { property: "og:description", content: description });
    upsertMeta('meta[property="og:type"]', { property: "og:type", content: schemaType === "Service" ? "article" : "website" });
    upsertMeta('meta[property="og:url"]', { property: "og:url", content: canonicalUrl });
    upsertMeta('meta[property="og:image"]', { property: "og:image", content: image });
    upsertMeta('meta[property="og:locale"]', { property: "og:locale", content: "tr_TR" });
    upsertMeta('meta[name="twitter:card"]', { name: "twitter:card", content: "summary_large_image" });
    upsertMeta('meta[name="twitter:title"]', { name: "twitter:title", content: title });
    upsertMeta('meta[name="twitter:description"]', { name: "twitter:description", content: description });
    upsertMeta('meta[name="twitter:image"]', { name: "twitter:image", content: image });
    upsertLink("canonical", canonicalUrl);

    let script = document.head.querySelector('script[data-testid="local-business-schema"]');
    if (!script) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.setAttribute("data-testid", "local-business-schema");
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(localBusinessSchema);
  }, [description, image, path, schemaType, title]);

  return null;
}